export enum CaseLocationPurposeType {
    UNKNOWN = 0,
    CORPORATEHEADQUARTERS = 1,
    SALESOFFICE = 2,
    RESIDENTIALADDRESS = 3,
    WORKADDRESS = 4,
    SEASONALADDRESS = 5,
    MAILINGADDRESS = 6,
    BILLINGADDRESS = 7,
    SHIPPINGADDRESS = 8,
}
